import {
  Client,
  Delegation,
  IClient,
  IDelegation,
  ISubclient,
  ISubclientData,
  ISubclientDetail,
  ISubclientDetailData,
  ISubclientServicepoint,
  SubclientServicepoint,
  IThirdcode,
  Thirdcode,
  ISubclientSyncResponse,
} from "@/entities";
import { ILimit, Limit } from "@/entities/limit";

export class Subclient implements ISubclient {
  readonly id?: number;
  readonly oidSol?: string;
  label?: string;
  readonly codeSol?: string;
  readonly idSmartcash?: string;
  readonly uniqueCode?: string;
  readonly description?: string;
  readonly active?: boolean;
  readonly delegation?: IDelegation;
  readonly client?: IClient;
  readonly thirdcodes?: IThirdcode[];
  readonly limits?: ILimit[];

  constructor(data: ISubclientData) {
    this.id = data.id;
    this.oidSol = data.oidSol;
    this.label = data.label;
    this.codeSol = data.codeSol;
    this.idSmartcash = data.idSmartcash;
    this.uniqueCode = data.uniqueCode;
    this.description = data.description;
    this.active = data.active;
    this.thirdcodes = data.thirdcodes?.map((thirdcode) => new Thirdcode(thirdcode));
    this.limits = data.limits?.map((limit) => new Limit(limit));

    if (data.delegation) {
      this.delegation = new Delegation(data.delegation);
    }

    if (data.client) {
      this.client = new Client(data.client);
    }
  }
}

export class SubclientDetail extends Subclient implements ISubclientDetail {
  readonly clientId: number;
  readonly servicepoints?: ISubclientServicepoint[];

  constructor(data: ISubclientDetailData) {
    super(data);

    this.clientId = data.clientId;

    this.servicepoints = data.servicepoints?.map(
      (servicepoint) => new SubclientServicepoint(servicepoint)
    );
  }
}

export class SubclientSyncResponse implements ISubclientSyncResponse {
  success: boolean;
  data: ISubclientDetailData | null;
  message?: string;

  constructor(success: boolean, data: ISubclientDetailData | null, message?: string) {
    this.success = success;
    this.data = data;
    this.message = message;
  }
}
